export const discountAmount = (discountAmount: string | number) => `You are receiving ${discountAmount} in discounts.`;
